module.exports = __webpack_public_path__ + "static/media/class1.8729b452.jpg";